<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 24"
    aria-hidden="true"
  >
    <path
      d="M3 8H0v4h3v12h5V12h3.64L12 8H8V6.33C8 5.38 8.19 5 9.11 5H12V0H8.19C4.6 0 3 1.58 3 4.61z"
    />
  </svg>
</template>
